/* src/app/components/menu-filters/menu-filters.component.scss */
.vegan_toggle {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (min-width: 991px) {
  .vegan_toggle {
    padding: 10px;
  }
}
.vegan_toggle .filter-toggle {
  display: flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: 28px;
  margin-right: 10px;
  cursor: pointer;
}
.vegan_toggle .filter-toggle ion-icon {
  width: 20px;
  height: 20px;
}
@media (min-width: 991px) {
  .vegan_toggle .filter-toggle ion-icon {
    width: 30px;
    height: 30px;
  }
}
.vegan_toggle .filter-toggle p {
  font-size: 14px;
  text-transform: capitalize;
  font-weight: bold;
  color: black;
  padding-left: 5px;
}
@media (min-width: 991px) {
  .vegan_toggle .filter-toggle p {
    font-size: 18px;
  }
}
.vegan_toggle .toggler {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #567E4A;
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.2) inset;
  padding: 1.5px 7px;
  border-radius: 50px;
  width: 175px;
  height: 50px;
  position: relative;
}
.vegan_toggle .toggler .toggler_item {
  padding: 0px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  line-height: 19px;
  color: #34A853;
  transition: all 0.4s;
  cursor: pointer;
  width: 33%;
  text-transform: capitalize;
  color: black;
}
.vegan_toggle .toggler .toggler_item.selected {
  z-index: 10;
}
.vegan_toggle .toggler .toggler_pin {
  position: absolute;
  color: red;
  top: -6px;
  width: 65px;
  height: 65px;
  border-radius: 50%;
  background: var(--ion-color-primary);
  box-shadow: 0px 4px 15px 0px rgba(79, 97, 79, 0.1490196078);
  transition: all 0.3s ease-out;
}
.vegan_toggle .toggler .toggler_pin .pin_img {
  height: 40px;
  width: 40px;
}
.vegan_toggle .toggler .toggler_pin.first {
  left: 0px;
}
.vegan_toggle .toggler .toggler_pin.second {
  left: 56px;
}
.vegan_toggle .toggler .toggler_pin.third {
  left: 110px;
}
.all-item {
  position: relative;
}
.all-item ion-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40px !important;
  height: 40px !important;
}
.all-item p {
  position: absolute;
  bottom: 20px;
  color: var(--ion-color-secondary);
  font-size: 15px;
  bottom: 4px;
  text-transform: uppercase;
}
.image-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 5px;
}
.image-block ion-icon {
  height: 30px;
}
.image-block .first-img {
  width: 30px !important;
  height: 30px !important;
}
.image-block .second-img {
  width: 25px !important;
  height: 25px !important;
}
.image-block p {
  color: white;
  font-size: 12px;
  text-transform: uppercase;
}
/*# sourceMappingURL=menu-filters.component.css.map */
